// src/components/Carousel.js
import React, { useState, useEffect } from 'react';
import image1 from '../assets/banners/banner1.webp';
import image2 from '../assets/banners/7361605.jpg';
const images = [
    image1,image2,image1
];

const Carousel = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex(prevIndex => (prevIndex + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="relative w-full h-[300px] md:h-[600px] overflow-hidden">
            {images.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    alt={`Banner ${i + 1}`}
                    className={`absolute w-full h-full object-cover transition-opacity duration-1000 ${index === i ? 'opacity-100' : 'opacity-0'}`}
                />
            ))}
        </div>
    );
};

export default Carousel;
